import { PostTopic, Post as PostType } from "../../../types/post";
import { createEffect, createMemo, Show } from "solid-js";
import { usePostsContext } from "../../../Provider/context";
import Mark from "mark.js";
import { AspectRatio } from "~/components/ui/aspect-ratio";
import { Text } from "~/components/ui/text";
import { Button } from "~/components/ui/button";
import { Icon } from "~/components/ui/icon";
import { mdiArrowLeft } from "@mdi/js";
import { Group } from "~/components/ui/group";
import { Badge } from "~/components/ui/badge";
import dayjs from "dayjs";

interface PostProps {
	post?: PostType;
}

export function Post(props: PostProps) {

	let contentContainer: HTMLDivElement | undefined;
	const { search, unselect, topics } = usePostsContext();

	createEffect(() => {

		const _search = search();

		if (!contentContainer) {
			return;
		}

		const mark = new Mark(contentContainer);
		mark.mark(_search, { separateWordSearch: false });
	});

	const topic = createMemo<PostTopic | undefined>(() => {
		const allTopics = topics();
		
		if (allTopics.length > 0) {
			return props.post?.topic || {
				id: "rest",
				name: "Overig",
			}
		}
	});

	return (
		<>
			<AspectRatio ratio={16 / 9}>
				<img
					class="size-full rounded-md object-cover shadow-md"
					src={props.post?.bannerUrl}
					alt={props.post?.title}
				/>
			</AspectRatio>
			<div ref={contentContainer} class="mt-8">
				<Group class="items-center">
					<div class="w-full flex flex-col">
						<Text class="font-semibold text-2xl mb-2">
							{props.post?.title}
						</Text>
						<Text class="text-sm">
							{dayjs(props.post?.publishedAt).format("dddd D MMMM YYYY")}
						</Text>
					</div>
					<Show when={topic()}>
						{(topic) => (
							<Badge variant="filled">
								{topic().name}
							</Badge>
						)}
					</Show>
				</Group>
				<div class="mt-4 mb-8 block h-max prose max-w-full">
					<div innerHTML={props.post?.content} />
				</div>
			</div>
			<Button
				class="w-full md:w-max"
				onClick={unselect}
			>
				<Icon class="mr-2" path={mdiArrowLeft} size="sm" />
				Terug
			</Button>
		</>
	);
}